import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Map, GlobalContext } from 'commons';

const drawCircle = point => {
  const d2r = Math.PI / 180;
  const r2d = 180 / Math.PI;
  const radius = 5;
  const earthsradius = 6356;
  const max = 40;

  const rlat = radius / earthsradius * r2d;
  const rlng = rlat / Math.cos(point.y * d2r);

  const extp = [];

  for (let i = 0; i < max + 1; i += 1) {
    const theta = Math.PI * (i / (max / 2));
    const lat = point.y + rlat * Math.sin(theta);
    const lng = point.x + rlng * Math.cos(theta);
    extp.push({ lat, lng });
  }

  return extp;
};

const CircleMap = ({ points }) => {
  const { lang, googleMapParam } = useContext(GlobalContext);

  return <Map lang={lang} googleMapParam={googleMapParam} stroke={false} paths={points.map(drawCircle)} />;
};

CircleMap.propTypes = {
  points: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default CircleMap;
